import React from 'react';
import { locationShape } from 'react-router/lib/PropTypes';
import OptInContainer from '../../../../containers/OptInContainer';
import FeatureFlagContainer from '../../../../containers/FeatureFlagContainer';

export default function BorrowingOptIn({ location }) {
  const renderOptIn = () => (
    <OptInContainer
      optedIn
      bundleName="nerf_borrowing"
      allowDismiss={false}
      showAdditionalMessage
      location={location} />
  );

  return (
    <div className="cp-borrowing-opt-in">
      <FeatureFlagContainer>
        {(flags) => flags.get('nerfBorrowing') ? null : renderOptIn() }
      </FeatureFlagContainer>
    </div>
  );
}

BorrowingOptIn.propTypes = {
  location: locationShape
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingOptIn/BorrowingOptIn.jsx